import type { ExploreContentItemContentOneOfThreesevenAuth } from './exploreContentItemContentOneOfThreesevenAuth';
import type { ExploreContentItemContentOneOfThreesevenBasicInfo } from './exploreContentItemContentOneOfThreesevenBasicInfo';
import type { ExploreContentItemContentOneOfThreesevenDetails } from './exploreContentItemContentOneOfThreesevenDetails';
import type { ExploreContentItemContentOneOfThreesevenMedia } from './exploreContentItemContentOneOfThreesevenMedia';

export type ExploreContentItemContentOneOfThreeseven = {
  /** 인증 컨텍스트 정보 */
  auth?: ExploreContentItemContentOneOfThreesevenAuth;
  basicInfo?: ExploreContentItemContentOneOfThreesevenBasicInfo;
  /** 토픽 상세 정보 */
  details?: ExploreContentItemContentOneOfThreesevenDetails;
  /** 미디어 정보 */
  media?: ExploreContentItemContentOneOfThreesevenMedia;
};
